import { GlobalReducerActions } from "./globalReducer";
import axiosInstance from "services/axiosInstance";
import { setMembersOrderStr } from "util/helpers";
import Endpoints from "constants/Endpoints";
import Tables from "constants/Tables";

const { setLoading, setNotificationMessage, setCustomedNotificationMessage } = GlobalReducerActions;
const { SECTION, LIST_ITEM } = Endpoints;
const { INVESTORS_TABLE } = Tables;

const NEW_INVESTOR = {
  name: "",
  description: "",
  website_url: "",
  linkedin_url: "",
  twitter_url: "",
  image: "",
};

const INVESTORS_REDUCER_INITIAL_STATE = {
  retrievedData: false,
  data: [],
  selectedInvestor: {},
  originalPositions: '',
  newPositions: '',
  newInvestor: { ...NEW_INVESTOR },
};

export const INVESTORS_REDUCER_TYPES = {
  GET_INVESTORS_DATA: "GET_INVESTORS_DATA",
  SET_INVESTORS_DATA: "SET_INVESTORS_DATA",
  GET_SELECTED_INVESTOR_DATA: "GET_SELECTED_INVESTOR_DATA",
  SET_SELECTED_INVESTOR_DATA: "SET_SELECTED_INVESTOR_DATA",
  SET_INVESTORS_RETRIEVED_DATA: "SET_INVESTORS_RETRIEVED_DATA",
  SET_NEW_INVESTOR_DATA: "SET_NEW_INVESTOR_DATA",
  SET_INVESTORS_NEW_POSITIONS_DATA: "SET_INVESTORS_NEW_POSITIONS_DATA",
};

export const investorsReducer = (
  state = INVESTORS_REDUCER_INITIAL_STATE,
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case INVESTORS_REDUCER_TYPES.GET_INVESTORS_DATA:
      const updatedPayload = [...payload];
      updatedPayload.forEach(item => {
        if (!item.originalPosition) {
          item.originalPosition = item.position
        }
      });
      return {
        ...state,
        data: updatedPayload,
        originalPositions: setMembersOrderStr(updatedPayload, true),
        newPositions: setMembersOrderStr(updatedPayload, true)
      };
    case INVESTORS_REDUCER_TYPES.SET_INVESTORS_DATA:
      return {
        ...state,
        data: payload,
      };
    case INVESTORS_REDUCER_TYPES.SET_INVESTORS_NEW_POSITIONS_DATA:
      return {
        ...state,
        newPositions: payload,
      };
    case INVESTORS_REDUCER_TYPES.GET_SELECTED_INVESTOR_DATA:
      return {
        ...state,
        selectedInvestor: payload,
      };
    case INVESTORS_REDUCER_TYPES.SET_SELECTED_INVESTOR_DATA:
      return {
        ...state,
        selectedInvestor: payload,
      };
    case INVESTORS_REDUCER_TYPES.SET_NEW_INVESTOR_DATA:
      return {
        ...state,
        newInvestor: payload,
      };
    case INVESTORS_REDUCER_TYPES.SET_INVESTORS_RETRIEVED_DATA:
      return {
        ...state,
        retrievedData: payload,
      };
    default:
      return state;
  }
};

const getInvestorsData = (kit) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await axiosInstance({
        method: "get",
        url: `${SECTION}/${kit}/${INVESTORS_TABLE}`,
      });
      if (response?.status === 200 && response.data) {
        dispatch({
          type: INVESTORS_REDUCER_TYPES.GET_INVESTORS_DATA,
          payload: response.data.item,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setLoading(false));
      dispatch({
        type: INVESTORS_REDUCER_TYPES.SET_INVESTORS_RETRIEVED_DATA,
        payload: true,
      });
    }
  };
};

const getSelectedInvestorData = (kit, id) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await axiosInstance({
        method: "get",
        url: `${LIST_ITEM}/${kit}/${INVESTORS_TABLE}/${id}`,
      });
      if (response?.status === 200 && response.data) {
        dispatch({
          type: INVESTORS_REDUCER_TYPES.GET_SELECTED_INVESTOR_DATA,
          payload: response.data.data,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setLoading(false));
      dispatch({
        type: INVESTORS_REDUCER_TYPES.SET_INVESTORS_RETRIEVED_DATA,
        payload: true,
      });
    }
  };
};

const setInvestorsData = (payload) => {
  const sortedPositions = payload.sort((a, b) => a.position - b.position);
  return async (dispatch) => {
    try {
      dispatch({
        type: INVESTORS_REDUCER_TYPES.SET_INVESTORS_DATA,
        payload: sortedPositions,
      });
    } catch (error) {
      console.log(error);
      dispatch(setLoading(false));
    }
  };
};

const setInvestorsNewPositions = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: INVESTORS_REDUCER_TYPES.SET_INVESTORS_NEW_POSITIONS_DATA,
        payload,
      });
    } catch (error) {
      console.log(error);
    }
  };
};

const setSelectedInvestorData = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: INVESTORS_REDUCER_TYPES.SET_SELECTED_INVESTOR_DATA,
        payload,
      });
    } catch (error) {
      console.log(error);
      dispatch(setLoading(false));
    }
  };
};

const setNewInvestorData = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: INVESTORS_REDUCER_TYPES.SET_NEW_INVESTOR_DATA,
        payload,
      });
    } catch (error) {
      console.log(error);
      dispatch(setLoading(false));
    }
  };
};

const saveChanges = (kit, newData) => {
  const data = [...newData];
  data.forEach(item => delete item.originalPosition);
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await axiosInstance({
        method: "post",
        url: SECTION,
        data: {
          kit,
          tableName: INVESTORS_TABLE,
          item: data,
        },
      });
      if (response?.status === 200) {
        dispatch({
          type: INVESTORS_REDUCER_TYPES.GET_INVESTORS_DATA,
          payload: response.data.item,
        });
        dispatch(setNotificationMessage('default_success'));
      }
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setNotificationMessage('default_error'));
      console.log(error);
      dispatch(setLoading(false));
    }
  };
};

const saveSelectedInvestorChanges = (kit, newData) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await axiosInstance({
        method: "put",
        url: LIST_ITEM,
        data: {
          kit,
          tableName: INVESTORS_TABLE,
          item: newData,
        },
      });
      if (response?.status === 200) {
        dispatch({
          type: INVESTORS_REDUCER_TYPES.GET_SELECTED_INVESTOR_DATA,
          payload: response.data,
        });
        dispatch(setNotificationMessage('default_success'));
      }
    } catch (error) {
      dispatch(setNotificationMessage('default_error'));
      console.log(error);
    } finally {
      dispatch(setLoading(false));
      dispatch({
        type: INVESTORS_REDUCER_TYPES.SET_INVESTORS_RETRIEVED_DATA,
        payload: false,
      });
    }
  };
};

const saveNewInvestor = (kit, newData) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await axiosInstance({
        method: "post",
        url: LIST_ITEM,
        data: {
          kit,
          tableName: INVESTORS_TABLE,
          item: newData,
        },
      });
      if (response?.status === 200) {
        dispatch({
          type: INVESTORS_REDUCER_TYPES.GET_INVESTORS_DATA,
          payload: response.data.item,
        });
        dispatch({
          type: INVESTORS_REDUCER_TYPES.SET_NEW_INVESTOR_DATA,
          payload: { ...NEW_INVESTOR },
        });
        dispatch(setCustomedNotificationMessage(`${newData.name} has been successfully added!`));
      }
    } catch (error) {
      dispatch(setNotificationMessage('default_error'));
      console.log(error);
    } finally {
      dispatch(setLoading(false));
      dispatch({
        type: INVESTORS_REDUCER_TYPES.SET_INVESTORS_RETRIEVED_DATA,
        payload: false,
      });
    }
  };
};

const deleteInvestorData = (kit, id) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await axiosInstance({
        method: "delete",
        url: LIST_ITEM,
        data: {
          kit,
          tableName: INVESTORS_TABLE,
          id,
        },
      });
      if (response?.status === 200) {
        const { name } = response.data.deletedItem;
        dispatch(setCustomedNotificationMessage(`${name} has been successfuly removed!`));
        dispatch({
          type: INVESTORS_REDUCER_TYPES.GET_INVESTORS_DATA,
          payload: response.data.updatedList,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setLoading(false));
    }
  };
};

export const InvestorsReducerActions = {
  getInvestorsData,
  setInvestorsData,
  getSelectedInvestorData,
  setSelectedInvestorData,
  setNewInvestorData,
  saveChanges,
  saveSelectedInvestorChanges,
  saveNewInvestor,
  deleteInvestorData,
  setInvestorsNewPositions,
};
